import * as React from 'react'
import {
    Grid,
    FormGroup,
    FormControlLabel,
    Radio,
    TextField,
    Select,
    MenuItem,
    Box,
    Typography,
} from '@mui/material'
import * as moment from 'moment'
import * as ReactDatetime from 'react-datetime'

type Props = {
    kedo: any
    state: any
    setPartialState: (updates: any) => void
}

export const StepTwo = ({ kedo, state, setPartialState }: Props) => {
    const isValidDate = (current: moment.Moment) => current.isAfter(moment())

    const secureKedocxs = state.kedocxs.filter(
        (item) =>
            Array.isArray(state.secureShareSettings?.kedocx) &&
            state.secureShareSettings.kedocx.includes(item.id)
    )

    return (
        <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 6 }}>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                    {kedo.t('step_two_title', { ns: 'secureshare' })}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                    {kedo.t('step_two_description', { ns: 'secureshare' })}
                </Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
                <Box sx={{ mb: 3 }}>
                    <Box
                        component="h3"
                        sx={{ fontSize: '1rem', fontWeight: 600, mb: 2 }}
                    >
                        {kedo.t('What do you want to share?', {
                            ns: 'secureshare',
                        })}
                    </Box>
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Radio
                                    name="share_type"
                                    value="positions"
                                    checked={state.shareType === 'positions'}
                                    onChange={() =>
                                        setPartialState({
                                            shareType: 'positions',
                                        })
                                    }
                                />
                            }
                            label={kedo.t('Data position of this dossier', {
                                ns: 'secureshare',
                            })}
                        />
                        <FormControlLabel
                            control={
                                <Radio
                                    name="share_type"
                                    value="kedocx"
                                    checked={state.shareType === 'kedocx'}
                                    disabled={!state.hasKedocxs}
                                    onChange={() =>
                                        setPartialState({ shareType: 'kedocx' })
                                    }
                                />
                            }
                            label={kedo.t('Template (kedocx)', {
                                ns: 'secureshare',
                            })}
                        />
                    </FormGroup>

                    {state.shareType === 'positions' && (
                        <Box sx={{ mt: 2 }}>
                            <Select
                                size="small"
                                fullWidth
                                value={state.shareTypeValue}
                                onChange={(e) =>
                                    setPartialState({
                                        shareTypeValue: e.target.value,
                                    })
                                }
                            >
                                <MenuItem value="">
                                    {kedo.t('Choose an option')}
                                </MenuItem>
                                {state.displayPositions.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {kedo.translateItem(
                                            item,
                                            'displayposition'
                                        )}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Box>
                    )}

                    {state.shareType === 'kedocx' && (
                        <Box sx={{ mt: 2 }}>
                            <Select
                                fullWidth
                                value={state.shareTypeValue}
                                onChange={(e) =>
                                    setPartialState({
                                        shareTypeValue: e.target.value,
                                    })
                                }
                            >
                                <MenuItem value="">
                                    {kedo.t('Choose an option')}
                                </MenuItem>
                                {secureKedocxs.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Box>
                    )}
                </Box>

                <Box sx={{ mb: 3 }}>
                    <Box
                        component="h3"
                        sx={{ fontSize: '1rem', fontWeight: 600, mb: 2 }}
                    >
                        {kedo.t('How long is the link valid?', {
                            ns: 'secureshare',
                        })}
                    </Box>
                    <ReactDatetime
                        closeOnSelect
                        timeFormat={false}
                        value={state.shareUntilDate}
                        isValidDate={isValidDate}
                        onChange={(date) =>
                            setPartialState({ shareUntilDate: date })
                        }
                    />
                </Box>
            </Grid>
        </Grid>
    )
}
